import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

export function webNotificationError(bool, message) {
  return {
    type: ActionType.WEBNOTIFICATION_SERVICE_ERROR,
    hasError: bool,
    webtoken: null,
    message,
    isLoading: false,
  }
}

export function webNotificationSuccess({ webtoken }) {
  return {
    type: ActionType.WEBNOTIFICATION_SERVICE_SUCCESS,
    webtoken,
    message,
    isLoading: false,
  }
}

export function webNotificationInProgress(bool) {
  return {
    type: ActionType.WEBNOTIFICATION_INPROGRESS,
    isLoading: bool,
  }
}

export function setWebToken(params) {
  return async (dispatch) => {
    try {
      dispatch(webNotificationInProgress(true))
      var data = await serviceInterface
        .NotificationService()
        .setWebToken(params)
      dispatch(webNotificationInProgress(false))
      if (data.error) {
        message.error(data.message)
        dispatch(webNotificationError(true, data.message))
      } else {
        dispatch(webNotificationSuccess(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(webNotificationInProgress(false))
      dispatch(webNotificationError(true, 'Something went wrong!'))
    }
  }
}
